<template>
  <div>
    <multiselect
        v-model="internalSelection"
        :options="allEquipments"
        :multiple="true"
        track-by="id"
        label="internalName"
        placeholder="Ausstattungen auswählen"
        :close-on-select="true"
        @input="onInput"
    />
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import axios from 'axios'

export default {
  name: 'EquipmentSelector',
  components: {Multiselect},
  props: {
    // Array von IDs vom Parent (Lesen)
    value: {
      type: Array,
      default: () => []
    }
  },
  model: {prop: 'value', event: 'input'},
  data() {
    return {
      allEquipments: [],         // vom Server geladene Optionen
      internalSelection: []      // aktuell ge-selected im Multiselect
    }
  },
  watch: {
    // wenn Parent neue IDs setzt, Multiselect updaten
    value: {
      immediate: true,
      handler(ids) {
        this.internalSelection = this.allEquipments.filter(e => ids.includes(e.id))
      }
    },
   /* internalSelection() {
      this.onInput()
    }*/
  },
  mounted() {
    axios.get('/api/package-equipments', {withCredentials: true})
        .then(({data}) => {
          this.allEquipments = data
          let selectedIds=this.value.map(el=>el.id)
          // sofort initial Selection anlegen
          this.internalSelection = this.allEquipments.filter(e => selectedIds.includes(e.id))

        })
        .catch(console.error)
  },
  methods: {
    onInput() {
      console.log("input")
      // 1) emit für v-model: nur Zahl-Array
      const ids = this.internalSelection.map(i => i.id)
      //this.$emit('input', ids)

      // 2) zusätzlich eigenes Event für Schreib-API: Array von {id}
      const payload = ids.map(id => id)
      this.$emit('input', payload)
    }
  }
}
</script>